import React from 'react'
import {EmojiPicker} from '@components/common/emoji-picker/emoji-picker'
import {useUserAgent} from '@containers/hooks'
import {TwReactionList} from './containers'
import {Reaction} from './reaction'
import {ReactionHint} from './reaction-hint'
import {ReactionsListProps} from './types'

export const ReactionsList = React.forwardRef(
  (
    {reactions, currentUserId, onSelect, className}: ReactionsListProps,
    ref
  ) => {
    const {browser} = useUserAgent()

    return (
      <TwReactionList ref={ref} className={className}>
        {reactions.map(x => (
          <Reaction
            key={x.smiley}
            value={x.smiley}
            count={x.reactedUsers.length}
            onClick={() => onSelect?.(x.smiley)}
            reacted={x.reactedUsers.some(e => e.userId === currentUserId)}
            hint={<ReactionHint users={x.reactedUsers} />}
            browser={browser}
          />
        ))}
        {onSelect && <EmojiPicker onSelect={onSelect} closeOnSelect large />}
      </TwReactionList>
    )
  }
)
